import {useNavigate} from "react-router-dom";
import {isNullOrUndefined} from "../../services/Validator";

export default function SystemTopNavigationItem({item, isActive}) {
    // Used in SystemTopBarNavigation to display
    // side navigation items

    // PROPERTIES
    let navigate = useNavigate()

    // BUILD
    if (isNullOrUndefined(item) || isNullOrUndefined(item.name) || isNullOrUndefined(item.route))
        return null
    return(
        <div className={`overflow-hidden group relative min-h-[72px] select-none 
                         bg-transparent text-greyLight9 hover:text-white
                         flex justify-center items-center px-[12px] md:px-[24px]
                         ${isActive ? "cursor-default text-white" 
                                    : "cursor-pointer"}`}
            onClick={isActive ? null : () => navigate(item.route)}>
            <span className="relative z-10 text-[16px] lg:text-[18px] whitespace-nowrap">
                {item.name}
            </span>
            <div className={`absolute inset-0 opacity-0 group-hover:opacity-30 transition-opacity duration-0
                             bg-[radial-gradient(ellipse_90%_120%_at_center_bottom,_rgba(114,206,159,0.55)_0%,_rgba(255,255,255,0)_50%)]
                             ${isActive ? "opacity-30" : ""}`}>
            </div>
        </div>
    );
}